import { Chip, Stack, Typography } from "@mui/material";
import IconBtn from "components/lib-ui/IconBtn";
import { useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DialogBox from "components/lib-ui/DialogBox";
import { RelocationForm } from "./RelocationForm";

export default function RelocationField({ savedRelocationData }) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [relocation , setRelocation] = useState(savedRelocationData?.data || null);
    
    let relocationJSX = null;
    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };
    if (relocation === null || relocation === undefined) {
        relocationJSX = (
            <>
                <Typography variant="body2">
                    No relocation information available.
                </Typography>
            </>
        );
    }

    if (relocation?.availability === false || relocation?.relocationAvailability === false) {
        relocationJSX = (
            <Typography variant="body2">
                Candidate is not willing to relocate.
            </Typography>
        );
    }

    if (relocation?.relocateAnywhere === true || relocation?.relocationAnywhere === true) {
        relocationJSX = (
            <Typography variant="body2">
                Candidate is willing to relocate anywhere.
            </Typography>
        );
    }

    if (
        ( relocation?.availability === true || relocation?.relocationAvailability === true) &&
        (relocation?.relocateAnywhere === false || relocation?.relocationAnywhere === false)
    ) {
        relocationJSX = (
            <Stack spacing={1} sx={{ width: "100%" }}>
                {relocation?.included?.length > 0 && (
                    <Stack spacing={1} sx={{ width: "100%" }}>
                        <Typography variant="body2">
                            Candidate is willing to relocate to:
                        </Typography>
                        <Stack direction="row" gap={1} flexWrap="wrap">
                            {relocation
                                ? relocation.included.map((item) => (
                                      <Chip
                                          key={item.id}
                                          label={`${item.title}`}
                                          color="primary"
                                      ></Chip>
                                  ))
                                : null}
                        </Stack>
                    </Stack>
                )}
                {relocation?.excluded?.length > 0 && (
                    <Stack spacing={1} sx={{ width: "100%" }}>
                        <Typography variant="body2">
                            Candidate is NOT willing to relocate to:
                        </Typography>
                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            sx={{ mb: 1 }}
                        >
                            {relocation
                                ? relocation.excluded.map((item) => (
                                      <Chip
                                          key={item.id}
                                          label={`${item.title}`}
                                          color="error"
                                      ></Chip>
                                  ))
                                : null}
                        </Stack>
                    </Stack>
                )}
            </Stack>
        );
    }

    return (
        <>
            <Stack
                direction="column"
                gap={1}
                mb={1}
                sx={{ position: "relative", gridColumn: "span 4" }}
            >
                <Typography variant="subtitle1" sx={{
                    fontWeight: 400,
                    fontSize: '0.75rem',
                    color: 'rgba(0, 0, 0, 0.6)',
                    textAlign: "left",
                }}>Relocation</Typography>
                <Stack sx={{ position: "relative" }}>
                    {relocationJSX}
                    <IconBtn
                        sx={{
                            opacity: 1,
                            marginLeft: "auto",
                            border: "unset",
                            background: "white",
                            position: "absolute",
                            right: 0,
                            top: "50%",
                            transform: " translateY(-50%)",
                        }}
                        icon={EditOutlinedIcon}
                        onClick={handleDialogOpen}
                    ></IconBtn>
                </Stack>
                <DialogBox
                    isDialogOpen={isDialogOpen}
                    setIsDialogOpen={setIsDialogOpen}
                    title="Add Relocation Locations"
                    floatCancel={true}
                    showActionButtons={false}
                >

                    <RelocationForm 
                        setIsDialogOpen={setIsDialogOpen} 
                        relocation={relocation} 
                        setRelocation={setRelocation}
                        />
                </DialogBox>
            </Stack>
        </>
    );
}
